import { gql } from "graphql-request";
export const GET_RECENT_POSTS_BY_CATEGORY_QUERY = gql`
    query getRecentPostsByCategory(
        $limit: [Int]
        $offset: [Int]
        $domainId: Int
        $published: Boolean
        $categoryId: Int
    ) {
        allPosts(
            limit: $limit
            offset: $offset
            categoryId: $categoryId
            published: $published
            isDeleted: false
            orderByDesc: createdAt
            domainId: $domainId
        ) {
            title
            translations {
                key
                value
                language
            }
            url {
                url
                isMain
                main {
                    url
                }
            }
        }
    }
`;
